/**
 * @generated SignedSource<<ba673a5256a4ad7be5fc69dfac2d754e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveTermDatesInput = {
  clientMutationId?: string | null | undefined;
  schoolTermDatesId: string;
};
export type RemoveTermDatesMutation$variables = {
  connections: ReadonlyArray<string>;
  input: RemoveTermDatesInput;
};
export type RemoveTermDatesMutation$data = {
  readonly removeTermDates: {
    readonly deletedTermDateId: string | null | undefined;
    readonly errors: any | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type RemoveTermDatesMutation = {
  response: RemoveTermDatesMutation$data;
  variables: RemoveTermDatesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedTermDateId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveTermDatesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveTermDatesPayload",
        "kind": "LinkedField",
        "name": "removeTermDates",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveTermDatesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveTermDatesPayload",
        "kind": "LinkedField",
        "name": "removeTermDates",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedTermDateId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "047b88241300d8bdebacd3585d1c4705",
    "id": null,
    "metadata": {},
    "name": "RemoveTermDatesMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveTermDatesMutation(\n  $input: RemoveTermDatesInput!\n) {\n  removeTermDates(input: $input) {\n    success\n    errors\n    deletedTermDateId\n  }\n}\n"
  }
};
})();

(node as any).hash = "0bd499b514eceee098c0b16ee3bfe3d1";

export default node;
